import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "list-unstyled"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center w-100"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["data-target", "aria-controls"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "list-unstyled anwendungsuebersicht" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Betriebsmitteilungen", -1)),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errormsg: "Beim Laden der Anwendungen ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at"
    }, {
      default: _withCtx(() => [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Derzeit keine Nachrichten vorhanden. "))
          : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bmsg, (bm, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "show-arrow mb-2",
                  key: index
                }, [
                  (_ctx.markNewItems === 'true' && _ctx.isNewEvent(bm.startEventDate))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.getNiceDate(bm.startEventDate)) + " ", 1),
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "new-dot" }, null, -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getNiceDate(bm.startEventDate)), 1)),
                  _createElementVNode("button", {
                    class: "btn btn-link btn-collapse",
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": '#collapse-'+bm.uid,
                    "aria-expanded": "false",
                    "aria-controls": '#collapse-'+bm.uid
                  }, [
                    _createTextVNode(_toDisplayString(bm.title) + " ", 1),
                    _cache[1] || (_cache[1] = _createElementVNode("span", {
                      class: "icon icon-navigation_pfeil_klein_rechts",
                      "aria-hidden": "true"
                    }, null, -1))
                  ], 8, _hoisted_6),
                  _createElementVNode("div", {
                    class: "collapse",
                    id: 'collapse-'+bm.uid
                  }, [
                    _createElementVNode("div", {
                      class: "pmb1",
                      innerHTML: _ctx.sanitizeHtml(bm.text || '')
                    }, null, 8, _hoisted_8),
                    (bm.documents)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-weight-bold mt-2" }, "Dokumente", -1)),
                          _createElementVNode("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bm.documents, (doc, indexdoc) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: indexdoc,
                                class: "show-arrow"
                              }, [
                                _createElementVNode("a", {
                                  href: _ctx.sanitizeUrl(_ctx.apiUrl + 'betriebsmeldungen/'+bm.uid+'/'+doc.uid),
                                  title: "Dokument in einem Fenster öffnen",
                                  target: "_blank",
                                  rel: "noreferrer noopener",
                                  class: "d-flex align-items-center text-black"
                                }, _toDisplayString(doc.name), 9, _hoisted_11)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_7)
                ]))
              }), 128))
            ]))
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}